export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/portfolio/index.js